/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_Download_ExcelInputs */

const vi_snapshot_download_excel = /** @type {(inputs: Snapshot_Download_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải Excel`)
};

/**

* @param {Snapshot_Download_ExcelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const snapshot_download_excel = /** @type {((inputs?: Snapshot_Download_ExcelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_Download_ExcelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_snapshot_download_excel(inputs)
});